<template>
  <div class="refund-page">
    <div class="page-header">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesRefundPage.line4_text') }}</div>
      <h1>{{ $t('wholesaler.AfterSalesRefundPage.line5_text') }}</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 退款信息 -->
      <div class="module">
        <div class="module-header"><span class="icon">📋</span><span class="title">{{ $t('wholesaler.AfterSalesRefundPage.line12_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesRefundPage.line14_text') }}</span><span class="value">{{ schemeText(detail.resolutionType) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesRefundPage.line15_text') }}</span><span class="value">{{ statusText(detail.resolutionStatus) }}</span></div>
        </div>
      </div>

      <!-- 金额明细 -->
      <div class="module" style="border:2px solid #ff4d4f;">
        <div class="module-header" style="background:#fff2f0;color:#ff4d4f;"><span class="icon">💰</span><span class="title">{{ $t('wholesaler.AfterSalesRefundPage.line21_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesRefundPage.line23_text') }}</span><span class="value">S$ {{ centsToAmount(detail.itemRefundAmount) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesRefundPage.line24_text') }}</span><span class="value">S$ {{ centsToAmount(detail.gstRefundAmount) }}</span></div>
          <div class="row" style="padding-top:12px;border-top:2px solid #f0f0f0;"><span class="label" style="font-weight:600;">{{ $t('wholesaler.AfterSalesRefundPage.line25_text') }}</span><span class="value amount">S$ {{ centsToAmount(detail.refundAmount) }}</span></div>
        </div>
      </div>

      <!-- 操作区 -->
      <div class="module action-section">
        <div class="module-body">
          <div v-if="detail.resolutionStatus === 'REFUND_PROCESSING'">
            <el-alert :title="$t('wholesaler.AfterSalesRefundPage.line33_title')" type="warning" :closable="false" style="margin-bottom:12px;"></el-alert>
            <el-button type="danger" size="large" style="width:100%;height:48px;" @click="confirmRefund" :loading="submitting">
              💰 确认退款
            </el-button>
          </div>
          <div v-else-if="detail.resolutionStatus === 'COMPLETED'">
            <el-alert :title="$t('wholesaler.AfterSalesRefundPage.line39_title')" type="success" :closable="false"></el-alert>
          </div>
          <div v-else>
            <el-alert :title="'当前状态: ' + detail.resolutionStatus" type="info" :closable="false"></el-alert>
          </div>
        </div>
      </div>

      <!-- 减免模式 -->
      <div v-if="detail.resolutionType === 'RELIEF'" class="module" style="border:2px solid #faad14;">
        <div class="module-header" style="background:#fffbe6;color:#d48806;"><span class="icon">📉</span><span class="title">{{ $t('wholesaler.AfterSalesRefundPage.line49_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesRefundPage.line51_text') }}</span><span class="value amount" style="color:#faad14;">S$ {{ centsToAmount(detail.reliefAmount) }}</span></div>
          <div v-if="detail.resolutionStatus === 'REFUND_PROCESSING'" style="margin-top:12px;">
            <el-button type="warning" size="large" style="width:100%;height:48px;" @click="confirmRefund" :loading="submitting">
              📉 确认减免
            </el-button>
          </div>
        </div>
      </div>

      <!-- 操作日志 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesRefundPage.line62_text') }}</span></div>
        <div class="module-body">
          <div v-if="actions.length > 0">
            <div class="log-item" v-for="log in actions" :key="log.id">
              <div class="log-dot"></div>
              <div class="log-content">
                <div class="log-title">{{ log.actionType }}</div>
                <div class="log-note" v-if="log.note">{{ log.note }}</div>
                <div class="log-time">{{ log.createdAt }}</div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><div class="empty-icon">📄</div><div class="empty-text">{{ $t('wholesaler.AfterSalesRefundPage.line74_text') }}</div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAfterSalesDetail, getAfterSalesActions, executeRefund } from '@/services/afterSales';

export default {
  name: 'AfterSalesRefundPage',
  data() {
    return {
      loading: false,
      submitting: false,
      detail: {},
      actions: []
    };
  },
  created() { this.loadDetail(); },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
        this.actions = await getAfterSalesActions(id);
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || e));
      } finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },
    schemeText(type) { const m = { RETURN_REFUND:'退货退款', EXCHANGE:'换货', RESEND:'补发', PARTIAL_REFUND:'部分退款', RELIEF:'减免', NO_ACTION:'不处理' }; return m[type] || type; },
    statusText(s) { const m = { REFUND_PROCESSING:'退款处理中', REFUND_COMPLETED:'退款完成', COMPLETED:'已完成' }; return m[s] || s; },
    centsToAmount(c) { if (!c) return '0.00'; return (c / 100).toFixed(2); },
    async confirmRefund() {
      this.$confirm('确认执行退款？此操作不可撤销', '确认退款', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.submitting = true;
        try {
          await executeRefund(this.detail.id);
          this.$message.success('退款已确认，售后流程完成');
          this.$router.push(`/wholesaler/after-sales/${this.detail.id}`);
        } catch (e) {
          this.$message.error('退款失败: ' + (e.message || e));
        } finally { this.submitting = false; }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.page-header { background: linear-gradient(135deg, #cf1322, #ff4d4f); color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 60px; background: #f5f5f5; min-height: calc(100vh - 80px); }

.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; }
.row .label { color: #999; }
.row .value { font-weight: 500; text-align: right; }
.row .value.amount { color: #ff4d4f; font-size: 15px; font-weight: 700; }
.row + .row { border-top: 1px dashed #f0f0f0; }

.action-section { border: 2px solid #ff4d4f; }

.log-item { display: flex; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f5f5f5; }
.log-item:last-child { border-bottom: none; }
.log-dot { width: 6px; height: 6px; border-radius: 50%; background: #457b9d; margin-top: 5px; flex-shrink: 0; }
.log-content { flex: 1; }
.log-title { font-size: 12px; font-weight: 500; }
.log-note { font-size: 11px; color: #666; margin-top: 1px; }
.log-time { font-size: 10px; color: #bbb; margin-top: 2px; }
.empty-state { text-align: center; padding: 24px 0; color: #999; }
.empty-icon { font-size: 32px; margin-bottom: 8px; }
.empty-text { font-size: 13px; }
</style>
